import { createAsyncThunk } from '@reduxjs/toolkit';

import { getUtilityCompanyListService } from 'services/utility_company.service';

export const getUtilityCompanyList = createAsyncThunk(
  'utilityCompany/list',
  async (_, thunkApi) => {
    try {
      const response = await getUtilityCompanyListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
